/**
 * Ticket Analysis dashboard tab — gated by LaunchDarkly `ticket-analysis-report`
 * (including camelCase variants commonly returned by `useFlags()`).
 */

export function isTicketAnalysisReportLdEnabled(
  flags: Record<string, unknown> | undefined
): boolean {
  if (!flags || typeof flags !== "object") {
    return false;
  }
  const f = flags as Record<string, unknown>;
  return (
    f.ticketAnalysisReport === true ||
    f.ticketanalysisreport === true ||
    f["ticket-analysis-report"] === true
  );
}
